// extracted by mini-css-extract-plugin
export default {"iconPlane":"airportDistanceFeature-module__iconPlane__qrlto"};